import { useEffect } from 'react';
import { useSignInState } from './signInState';
import useGetCustomerFeatureFlags from '../Hooks/useGetTenantFeatures';

interface FeatureFlagsLoaderProps {
  children?: React.ReactNode;
}

export const FeatureFlagsLoader: React.FC<FeatureFlagsLoaderProps> = ({ children }) => {
  const { signInState, setSignInState } = useSignInState();
  const { featureFlags } = useGetCustomerFeatureFlags(
    signInState.currentCustomerID > 0 ? signInState.currentCustomerID : null
  );

  useEffect(() => {
    if (featureFlags && signInState.currentCustomerID > 0) {
      setSignInState((prevState) => ({
        ...prevState,
        featureFlags,
      }));
    }
  }, [featureFlags, signInState.currentCustomerID, setSignInState]);

  return <>{children}</>;
};

export default FeatureFlagsLoader;

